.community-guidelines {
  .number {
    width: 8px;
  }

  .text {
    word-wrap: break-word;
  }

  .caret {
    display: inline-block;
    background-color: var(--color-moderate);
    transition: transform 0.2s ease-in-out;

    &.open {
      transform: rotate(-180deg);
    }
  }
}
